import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "row no-gutters mb-4"
};
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", {
    class: "col-12 bg-white border rounded py-3 pl-3 font7-responsive",
    style: { "border-left": "8px solid #a4ff78 !important" }
}, [
    /*#__PURE__*/ _createElementVNode("i", { class: "icon-brand_user font5" }),
    /*#__PURE__*/ _createTextVNode(" Hast Du bereits ein Nutzerkonto? "),
    /*#__PURE__*/ _createElementVNode("span", {
        class: "strong text-underline text-uppercase font-italic needs_login",
        style: { "cursor": "pointer" }
    }, " JETZT EINLOGGEN ")
], -1);
const _hoisted_3 = [
    _hoisted_2
];
const _hoisted_4 = { class: "row" };
const _hoisted_5 = {
    key: 1,
    class: "row mb-xl-4 mb-3"
};
const _hoisted_6 = { class: "col-12" };
const _hoisted_7 = { class: "col-12 bg-white border rounded" };
const _hoisted_8 = { class: "row" };
const _hoisted_9 = { class: "col-12 pt-3 text-right" };
const _hoisted_10 = {
    class: "font4 strong pr-md-3 pr-1",
    style: { "hyphens": "auto" }
};
const _hoisted_11 = {
    key: 0,
    class: "row"
};
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("div", { class: "col-12 pb-1 pt-1 text-right" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "font7-responsive pr-md-3 pr-1 fc-gray1 text-right d-lg-inline-block" }, [
        /*#__PURE__*/ _createTextVNode(" zzgl. Versand: 3,99 € "),
        /*#__PURE__*/ _createElementVNode("br"),
        /*#__PURE__*/ _createElementVNode("div", { class: "pt-2 text-right" }, "Kostenloser Versand ab 30 €")
    ])
], -1);
const _hoisted_13 = [
    _hoisted_12
];
const _hoisted_14 = {
    key: 1,
    class: "row"
};
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("div", { class: "col-12 pb-1 pt-2 text-right font7-responsive" }, [
    /*#__PURE__*/ _createTextVNode(" Versand: "),
    /*#__PURE__*/ _createElementVNode("span", { class: "badge badge-light-green p-y-1 p-x-2 mr-md-3 font-weight-normal font8-responsive" }, " Kostenlos ")
], -1);
const _hoisted_16 = [
    _hoisted_15
];
const _hoisted_17 = {
    key: 2,
    class: "row"
};
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("div", { class: "col-12 pb-1 pt-1 text-right" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "font7-responsive pr-md-3 pr-1 fc-gray1 text-right d-lg-inline-block" }, [
        /*#__PURE__*/ _createTextVNode(" zzgl. Deiner Auswahl: "),
        /*#__PURE__*/ _createElementVNode("br"),
        /*#__PURE__*/ _createTextVNode(" Expressversand: 6,99 € "),
        /*#__PURE__*/ _createElementVNode("br"),
        /*#__PURE__*/ _createElementVNode("div", { class: "pt-2 text-right" }, "Diese Auswahl kannst Du im Checkout noch ändern")
    ])
], -1);
const _hoisted_19 = [
    _hoisted_18
];
const _hoisted_20 = {
    key: 3,
    class: "row"
};
const _hoisted_21 = { class: "col-12 pb-4 pt-0 text-right font7-responsive pointerhover" };
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("i", { class: "icon-fragezeichen fc-gray1 mr-2" }, null, -1);
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("span", { class: "badge badge-light-green p-y-1 p-x-2 mr-md-3 font-weight-normal font8-responsive" }, " Inklusive ", -1);
const _hoisted_24 = /*#__PURE__*/ _createStaticVNode("<div class=\"row px-3 p-2 border-top\"><div class=\"placeholder order-1 col-lg-4 d-lg-block d-none col-md-6 col-12\"></div><div class=\"p-2 col-lg-4 col-md-6 order-2\"><a href=\"/kaufen\" class=\"buttonBase buttonBlueInverted font6-responsive\" style=\"width:100%;\"> Weiter einkaufen </a></div><div class=\"order-3 p-2 col-lg-4 col-md-6 col-12\"><a href=\"/kaufen/checkout\" title=\"Zur Kasse\" id=\"buy-now\" class=\"buttonBase buttonGreen font6-responsive [ JS_Sticky_Anchor_To_Checkout ]\" style=\"width:100%;\"> Zur Kasse </a></div></div>", 1);
const _hoisted_25 = {
    key: 2,
    class: "row"
};
const _hoisted_26 = /*#__PURE__*/ _createStaticVNode("<div class=\"col-12\"><div class=\"bg-white border rounded mb-3 text-center\"><h2 class=\"h5-responsive strong px-lg-3 pt-5\">Du hast noch keine Produkte im Warenkorb.</h2><div class=\"mt-4 pb-4\"><a href=\"/kaufen\" class=\"buttonBase buttonBlueInverted mb-3\" style=\"width:400px;max-width:100%;\"> Jetzt Produkte entdecken </a></div></div></div>", 1);
const _hoisted_27 = [
    _hoisted_26
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_product_box_big = _resolveComponent("product-box-big");
    const _component_formatted_price = _resolveComponent("formatted-price");
    const _component_open_popup_button = _resolveComponent("open-popup-button");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        (!_ctx.isLogin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.current_products, (cart_item, index) => {
                return (_openBlock(), _createBlock(_component_product_box_big, {
                    "cart-item": cart_item,
                    index: index,
                    key: cart_item.id,
                    class: _normalizeClass(_ctx.current_products.length > 1 ? 'col-xxl-6' : '')
                }, null, 8, ["cart-item", "index", "class"]));
            }), 128))
        ]),
        (_ctx.isCartFilled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("span", _hoisted_10, [
                                    _createTextVNode(" Gesamtsumme: "),
                                    _createVNode(_component_formatted_price, {
                                        class: "d-inline-block",
                                        price: _ctx.total
                                    }, null, 8, ["price"])
                                ])
                            ])
                        ]),
                        (_ctx.currentShippingIdentifier === 'flat')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
                            : _createCommentVNode("", true),
                        (_ctx.currentShippingIdentifier === 'flat_free')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
                            : _createCommentVNode("", true),
                        (_ctx.currentShippingIdentifier === 'express')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
                            : _createCommentVNode("", true),
                        (_ctx.hasWarrantyForAll)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                _createElementVNode("div", _hoisted_21, [
                                    _createVNode(_component_open_popup_button, { "popup-name": "guaranteePopup" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(" 36 Monate Garantie "),
                                            _hoisted_22,
                                            _hoisted_23
                                        ]),
                                        _: 1
                                    })
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        _hoisted_24
                    ])
                ])
            ]))
            : _createCommentVNode("", true),
        (_ctx.isCartFilled === false)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_27))
            : _createCommentVNode("", true)
    ], 64));
}
